import userConstants from '../actiontypes/user';
import { getPersonalDetail } from '../../api/UserService';

function getPersonalInfo() {
  return dispatch => {
    dispatch({ type: userConstants.PERSONAL_DETAIL_REQUEST });

    getPersonalDetail().then(
      response => {
        dispatch({
          type: userConstants.PERSONAL_DETAIL_SUCCESS,
          payload: response.data,
        });
      },
      () => {
        dispatch({ type: userConstants.PERSONAL_DETAIL_FAILURE });
      }
    );
  };
}

function changeEmail(payload) {
  return { type: userConstants.EMAIL_CHANGED, payload };
}

const userActions = {
  getPersonalInfo,
  changeEmail
};

export default userActions;
